import { hasPermission } from '@/app/store/auth'
import type { User } from '@/types/entities'

/**
 * Does this user hold a permission, named as the catalogue names it ('canvas.view')?
 *
 * Read from the /auth/me user (useMe), never the login-shaped user the auth store may briefly hold,
 * which carries no permissions at all - reading that one denies everyone for a moment, or for good.
 * A permission arrives either as { resource, action } or by its full name; both are accepted.
 *
 * Every feature is permission-controlled (Andrew, 29 Sep 2026); this is the one place the client
 * reads one, so a route guard, a menu entry and a button agree.
 */
export function userHasPermission(user: User | null | undefined, name: string): boolean {
    if (!user) return false
    const dot = name.indexOf('.')
    if (dot > 0 && hasPermission(user, name.slice(0, dot), name.slice(dot + 1))) return true
    return (user.roles ?? []).some(
        (role) => typeof role === 'object' && role !== null && (role.permissions ?? []).some((p) => p?.name === name),
    )
}
